import { FunctionComponent, useEffect, useState } from "react";
import Modal from "./Modal";
import Button from "../Button";
import { buttonTypes, userTypes } from "src/utils/types";
import { useAuth } from "src/context/AuthContext";
import { dynamo } from "src/utils";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../LoadingSpinner";
import { DropdownWithRegister } from "src/components/inputs";
import { useForm } from "react-hook-form";
import { AccountTypes, Consultant } from "src/utils/types/UserTypes";
import { ToastStatus, useToast } from "src/context/ToastContext";

interface IAssignLeadModalProps {
  open: boolean;
  client: userTypes.Client;
  toggleModal: () => void;
}

const AssignLeadModal: FunctionComponent<IAssignLeadModalProps> = ({
  open,
  client,
  toggleModal,
}) => {
  const { user } = useAuth();
  const { setToast } = useToast();
  const navigate = useNavigate();

  const [loading, setLoading] = useState<boolean>(true);
  const [consultants, setConsultants] = useState<Consultant[]>([]);
  const { register, watch, handleSubmit } = useForm({
    defaultValues: {
      assignedLead: "",
    },
  });

  const save = async (values: any) => {
    try {
      const { assignedLead } = values;

      if (!assignedLead.length) return;

      let assigned;
      if (
        assignedLead === user?.userId &&
        (user?.userType === AccountTypes.NEATT ||
          user?.userType === AccountTypes.MANAGER)
      ) {
        assigned = user;
      } else {
        assigned = consultants.filter(
          (consultant) => consultant.userId === assignedLead
        )[0];
      }

      if (!assigned) return;

      client.leadAssigned = {
        id: assigned.userId,
        name: assigned.userInfo.name,
      };

      const result = await dynamo.mutations.putUser(client);

      if (result.status === 201) {
        setToast({
          message: "Lead Assigned",
          status: ToastStatus.SUCCESS,
        });
        navigate(0);
      }
    } catch (error: any) {
      setToast({
        message: error?.message || "Lead Assignment Failed",
        status: ToastStatus.FAIL,
      });
    }
  };

  const fetchConsultants = async () => {
    try {
      const result = await dynamo.fetch.usersByType(
        userTypes.AccountTypes.NEATT
      );

      setConsultants([lead, ...result?.users]);
    } catch (error: any) {
      setToast({
        message: error?.message || "Failed to Fetch Consultants",
        status: ToastStatus.FAIL,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!consultants.length) fetchConsultants();
  }, [client]);

  const options = consultants.map((consultant: Consultant) => {
    console.log(consultant);
    return {
      label: consultant.userInfo?.name,
      value: consultant?.userId,
    };
  });

  if (user && user.userType !== AccountTypes.REFERRAL) {
    options.push({
      label: user?.userInfo?.name,
      value: user.userId,
    });
  }

  return (
    <>
      <Button text="Assign Lead" onClick={toggleModal} />
      <Modal
        open={open}
        title="Assign Lead"
        content={
          loading ? (
            <LoadingSpinner />
          ) : (
            <>
              <DropdownWithRegister
                id="assignedLead"
                options={options}
                register={register}
              />

              <div className="flex justify-evenly">
                <Button
                  text="Cancel"
                  theme={buttonTypes.BUTTON_THEME_TYPES.PRIMARY_INVERSE}
                  onClick={toggleModal}
                  styles="mr-4"
                />
                <Button text="Save" onClick={handleSubmit(save)} />
              </div>
            </>
          )
        }
        onClose={toggleModal}
      />
    </>
  );
};

export default AssignLeadModal;

const lead = {
  userId: "14c874a8-20a1-7073-7e6d-5ae98d26a760",
  userType: "Manager",
  metadata: {
    agreedToTerms: true,
    createdAt: "2025-11-13T15:36:15.753Z",
    cus_id: "4500109",
    firstLogin: true,
    stripeId: "",
    updatedAt: "2025-11-13T15:36:15.753Z",
  },
  userInfo: {
    email: "ella.rice@clientvitals.com",
    name: "Ella Rice",
    phone: "8025788779",
  },
};
